import { useEffect, useState } from "react";
import { getConnectionKeys } from "../services/connectionKeysService";

interface FetchConnectionKeyParams {
  filterKeys?: any;
  setIsLoading: (loading: boolean) => void;
  type?: string;
  disabled?: boolean; // Add disabled parameter to prevent API calls
}
const useFetchConnectionKey = ({
  filterKeys,
  setIsLoading,
  type,
  disabled = false, // Default to false to maintain backward compatibility
}: FetchConnectionKeyParams) => {
  const [connectionKeysData, setConnectionKeysData] = useState<any[]>([]);
  useEffect(() => {
    const getConnectionKeysData = async () => {
      setIsLoading(true);
      try {
        if (type) {
          const result = await getConnectionKeys(type);
          setConnectionKeysData(result);
        } else {
          const result = await getConnectionKeys();
          const filteredResult = result?.filter((item: any) =>
            filterKeys.includes(item.id)
          );
          setConnectionKeysData(filteredResult);
        }
      } catch (err) {
        setConnectionKeysData([]);
      } finally {
        setIsLoading(false);
      }
    };
    !disabled && (filterKeys?.length > 0 || type) && getConnectionKeysData();
  }, [filterKeys, type]); // ✅ Removed setIsLoading to prevent infinite loops

  return [connectionKeysData];
};

export default useFetchConnectionKey;
